
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artefacts",
      function () {
        return require("private-next-pages/artefacts/index.tsx");
      }
    ]);
  